/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_Awaiting_PaymentInputs */

const en_so_status_awaiting_payment = /** @type {(inputs: So_Status_Awaiting_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting payment`)
};

/**
* | output |
* | --- |
* | "Awaiting payment" |
*
* @param {So_Status_Awaiting_PaymentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_awaiting_payment = /** @type {((inputs?: So_Status_Awaiting_PaymentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_Awaiting_PaymentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_awaiting_payment(inputs)
});